import { motion } from "framer-motion";
import { PageHeader, StartCTA } from "@/components/site/primitives";

const reveal = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

const facets = [
  ["It has users.", "Real people with real workflows \u2014 not a demo."],
  ["It has architecture.", "Decisions today that either let it grow or quietly limit it."],
  ["It has data.", "Modeled, protected and useful long after launch."],
  ["It has security.", "Considered from the start, not bolted on at the end."],
  ["It has business logic.", "The rules that make the product behave correctly."],
  ["It has economics.", "A mechanism that lets the product sustain itself."],
];

export default function Why() {
  return (
    <div>
      <PageHeader
        label="WHY AIROTECH"
        title={"AI changed who\ncan build."}
        intro="Anyone can prompt. Anyone can generate code. Anyone can ask an LLM to create an application. But a product isn't a prompt."
      />

      <section className="py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-px bg-[#141414] rounded-2xl overflow-hidden border border-[#141414]">
            {facets.map(([t, d], i) => (
              <motion.div key={t} {...reveal} transition={{ ...reveal.transition, delay: (i % 2) * 0.06 }}
                className="bg-[#070707] p-8 md:p-10">
                <div className="font-heading text-xl md:text-2xl text-white">{t}</div>
                <p className="mt-3 text-sm md:text-base text-zinc-500 leading-relaxed">{d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-36 border-t border-[#141414]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <motion.h2 {...reveal} className="font-heading font-extrabold tracking-tighter leading-[1] text-4xl md:text-6xl">
            AI can generate the pieces.<br />
            <span className="text-cyan-400">Experience knows how to put them together.</span>
          </motion.h2>
        </div>
      </section>

      <section className="py-24 md:py-32 border-t border-[#141414]">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <motion.div {...reveal} className="mono-label text-zinc-500 mb-12">THE FUSION</motion.div>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              ["Business experience", "Knowing what makes a product viable, not just functional."],
              ["Technology", "Sound architecture, data and systems that hold up over time."],
              ["Product thinking", "Designing around real people and the jobs they need done."],
              ["Modern AI", "Accelerating the build without cutting the corners that matter."],
            ].map(([t, d], i) => (
              <motion.div key={t} {...reveal} transition={{ ...reveal.transition, delay: i * 0.06 }}>
                <div className="h-px w-10 bg-cyan-400 mb-6" />
                <div className="font-heading text-lg text-white">{t}</div>
                <p className="mt-3 text-sm text-zinc-500 leading-relaxed">{d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <StartCTA />
    </div>
  );
}
